angular.module 'zc.core'

.filter 'searchProject', ->
  (projects, filter) ->
    return projects unless filter
    projects.filter (project) ->
      _.includes(project.title, filter) || _.includes(project.apikey, filter)



// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/core/filters/search_project.filter.coffee